export default function lowercase(str) {
    return str.charAt(0).toLowerCase() + str.slice(1);
}
